import { render, staticRenderFns } from "./CourseGrades.vue?vue&type=template&id=0a00bfa8"
import script from "./CourseGrades.vue?vue&type=script&lang=js"
export * from "./CourseGrades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports